'use client';

import { SmallCard } from '@/features/client/Blog/SmallCard';
import { formatDate } from '@/helpers/formatDate';
import { devices } from '@/styles/breakpoints';
import React from 'react';
import styled from 'styled-components';

export const ContentWrapper = ({ data }) => {
  return (
    <Wrapper>
      {data?.map((item) => (
        <Card key={item.id}>
          <SmallCard
            item={{ ...item, formattedDate: formatDate(item.created_at) }}
          />
        </Card>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  @media only screen and ${devices.desktop} {
    gap: 48px;
  }
`;

const Card = styled.div`
  max-width: 540px;
  width: 100%;
  background-color: white;
`;
